/* global rp$, $ajax */
const runScriptOnReady = require('public/js/lib/run-script-on-ready');
const csrf = require('public/js/lib/csrf');

function productSubscription() {
	// Only initialize if rp$ is available (jQuery wrapper)
	if (typeof rp$ === 'undefined' || !rp$) {
		return;
	}

	const $waitlistModal = rp$('#backorderWaitlistModal');
	const $waitlistForm = rp$('#backorder-waitlist-form');
	const $emailInput = rp$('#waitlist-email');
	const $messageDiv = rp$('#waitlist-message');
	
	// Track last submitted email to prevent clearing error messages for same email
	let lastSubmittedEmail = '';
	
	/**
	 * Validate email format
	 * Rejects emails with invalid characters like $, #, /, !, %, ^, & in local part
	 * and ensures proper domain format
	 * @param {string} email - Email address to validate
	 * @returns {boolean} - True if valid, false otherwise
	 */
	function isValidEmailFormat(email) {
		if (!email || typeof email !== 'string') {
			return false;
		}
		
		// Trim whitespace
		email = email.trim();
		
		// Basic length check
		if (email.length === 0 || email.length > 128) {
			return false;
		}
		
		// Check for @ symbol
		const atIndex = email.indexOf('@');
		if (atIndex === -1 || atIndex === 0 || atIndex === email.length - 1) {
			return false;
		}
		
		// Split into local and domain parts
		const localPart = email.substring(0, atIndex);
		const domainPart = email.substring(atIndex + 1);
		
		// Validate local part
		// Allow: alphanumeric, dots, hyphens, underscores, plus signs
		// Reject: special characters like $, #, /, !, %, ^, &, etc.
		const localPartRegex = /^[a-zA-Z0-9._+-]+$/;
		if (!localPartRegex.test(localPart)) {
			return false;
		}
		
		// Local part cannot start or end with a dot
		if (localPart.startsWith('.') || localPart.endsWith('.') || localPart.startsWith('-') || localPart.endsWith('-')) {
			return false;
		}
		
		// Local part cannot have consecutive dots
		if (localPart.includes('..')) {
			return false;
		}
		
		// Validate domain part
		// Domain cannot be empty
		if (domainPart.length === 0) {
			return false;
		}
		
		// Domain cannot start with a dot
		if (domainPart.startsWith('.')) {
			return false;
		}
		
		// Domain must contain at least one dot
		if (!domainPart.includes('.')) {
			return false;
		}
		
		// Domain must have valid TLD (at least 2 characters after last dot)
		const lastDotIndex = domainPart.lastIndexOf('.');
		const tld = domainPart.substring(lastDotIndex + 1);
		if (tld.length < 2 || !/^[a-zA-Z0-9-]+$/.test(tld)) {
			return false;
		}
		
		// Domain part should only contain alphanumeric, dots, and hyphens
		const domainPartRegex = /^[a-zA-Z0-9.-]+$/;
		if (!domainPartRegex.test(domainPart)) {
			return false;
		}
		
		// Domain cannot have consecutive dots
		if (domainPart.includes('..')) {
			return false;
		}
		
		return true;
	}
	
	// Clear error message when email input changes
	if ($emailInput && $emailInput.length > 0) {
		$emailInput.on('input change', function() {
			const currentEmail = rp$(this).val().trim();
			// Only clear error message if email has changed from last submitted
			if (currentEmail !== lastSubmittedEmail && $messageDiv.hasClass('error')) {
				$messageDiv.hide().removeClass('error').html('');
			}
		});
	}
	
	// Auto-focus email field when modal opens
	if ($waitlistModal && $waitlistModal.length > 0) {
		$waitlistModal.on('shown.bs.modal', function() {
			if ($emailInput && $emailInput.length > 0) {
				// Small delay to ensure modal animation completes
				setTimeout(function() {
					$emailInput.focus();
					// If field has pre-filled value, select it for easy editing
					if ($emailInput.val()) {
						$emailInput.select();
					}
				}, 100);
			}
		});
		
		// Reset form when modal is closed
		$waitlistModal.on('hidden.bs.modal', function() {
			if ($waitlistForm && $waitlistForm.length > 0) {
				$waitlistForm[0].reset();
			}
			$messageDiv.hide().removeClass('success error').html('');
			const $submitBtn = rp$('#waitlist-submit-btn');
			$submitBtn.prop('disabled', false).removeClass('loading');
			// Reset last submitted email when modal closes
			lastSubmittedEmail = '';
		});
	}
	
	// Handle button click instead of form submit to prevent page reload
	rp$(document).on('click', '#waitlist-submit-btn', function(e) {
		e.preventDefault();
		e.stopPropagation();
		
		const $form = rp$('#backorder-waitlist-form');
		const $submitBtn = rp$(this);
		
		// Disable submit button
		$submitBtn.prop('disabled', true).addClass('loading');
		
		// Get data from module and form
		const email = rp$('#waitlist-email').val().trim();
		const data = {
			mpn_stripped: rp$('.product-purchase-module').data('sku-stripped') || '',
			brand_key: rp$('.product-purchase-module').data('catalog') || '',
			email: email,
		};
		
		// Add CSRF token to request data (required for security)
		const csrfToken = csrf.getToken();
		if (!csrf.isValidToken(csrfToken)) {
			console.error('Product Subscription: CSRF token not available');
			$messageDiv.addClass('error').html('Security token missing. Please refresh the page and try again.').show();
			$submitBtn.prop('disabled', false).removeClass('loading');
			return false;
		}
		
		const csrfData = csrf.getCsrfRequestData(csrfToken);
		csrfData.forEach(function(csrfItem) {
			Object.assign(data, csrfItem);
		});
		
		// Only clear error message if email has changed from last submission
		if (email !== lastSubmittedEmail) {
			$messageDiv.hide().removeClass('error').html('');
		}
		
		// Validate email
		if (!data.email) {
			$messageDiv.addClass('error').html('Please enter your email address').show();
			$submitBtn.prop('disabled', false).removeClass('loading');
			lastSubmittedEmail = ''; // Reset on validation error
			return false;
		}
		
		// Validate email format
		if (!isValidEmailFormat(data.email)) {
			$messageDiv.addClass('error').html('Please enter a valid email address').show();
			$submitBtn.prop('disabled', false).removeClass('loading');
			lastSubmittedEmail = ''; // Reset on validation error
			return false;
		}
		
		// Update last submitted email
		lastSubmittedEmail = email;
		
		// Get AJAX function (use $ajax if available, otherwise use rp$.ajax)
		const ajaxFn = (typeof $ajax !== 'undefined' ? $ajax : null) ?? rp$?.ajax ?? null;
		
		if (!ajaxFn) {
			console.error('Product Subscription: AJAX function not available');
			$messageDiv.addClass('error').html('An error occurred. Please try again later.').show();
			$submitBtn.prop('disabled', false).removeClass('loading');
			return false;
		}
		
		// Submit via AJAX with CSRF protection
		ajaxFn({
			type: 'POST',
			url: '/ajax/backorder-waitlist/subscribe',
			dataType: 'json',
			contentType: 'application/json',
			data: JSON.stringify(data),
			success: function(response) {
				if (response && response.status === 'ok') {
					// Close the form modal first
					$waitlistModal.modal('hide');
					
					// Show success modal after form modal closes
					$waitlistModal.one('hidden.bs.modal', function() {
						const $successModal = rp$('#backorderWaitlistSuccessModal');
						if ($successModal && $successModal.length > 0) {
							// Update success message from response
							if (response.message) {
								const $successMessage = rp$('.waitlist-success-message', $successModal);
								if ($successMessage.length > 0) {
									$successMessage.html(response.message);
								}
							}
							$successModal.modal('show');
						}
					});
				} else {
					// Use error message from response
					const message = response?.message ?? '';
					if (message) {
						$messageDiv.addClass('error').html(message).show();
					}
					$submitBtn.prop('disabled', false).removeClass('loading');
				}
			},
			error: function(xhr) {
				// Use error message from response
				let errorMessage = '';
				try {
					const response = JSON.parse(xhr.responseText);
					errorMessage = response?.message ?? '';
				} catch (e) {
					// Response is not valid JSON, use empty string
				}
				if (errorMessage) {
					$messageDiv.addClass('error').html(errorMessage).show();
				}
				$submitBtn.prop('disabled', false).removeClass('loading');
			}
		});
		
		return false;
	});
	
	// Also handle form submit as a fallback (though button is now type="button")
	rp$(document).on('submit', '#backorder-waitlist-form', function(e) {
		e.preventDefault();
		e.stopPropagation();
		return false;
	});
}

rp$.fn.product_subscription = productSubscription;

runScriptOnReady('product_subscription', productSubscription);

